import { sayings } from '../types/sayings'

function getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export const getRandomSaying = () => {
    return sayings[getRandomInt(0, 99)]
}
